import api from './api';

export const getSubjectiveExams = async () => {
    const res = await api.get('/subjective-exams/');
    return res.data;
};

export const createSubjectiveExam = async (data) => {
    const res = await api.post('/subjective-exams/', data);
    return res.data;
};

export const updateSubjectiveExam = async (examId, data) => {
    const res = await api.put(`/subjective-exams/${examId}`, data);
    return res.data;
};

export const deleteSubjectiveExam = async (examId) => {
    const res = await api.delete(`/subjective-exams/${examId}`);
    return res.data;
};

export const getSubjectiveExam = async (examId) => {
    const res = await api.get(`/subjective-exams/${examId}`);
    return res.data;
};

export const startSubjectiveExam = async (examId) => {
    const res = await api.post(`/subjective-exams/${examId}/start`);
    return res.data;
};

export const autoSaveAnswer = async (submissionId, questionId, pageNumber, canvasData) => {
    const res = await api.put(`/subjective-exams/submissions/${submissionId}/answers/${questionId}`, {
        page_number: pageNumber,
        canvas_data: canvasData
    });
    return res.data;
};

export const submitSubjectiveExam = async (submissionId, pdfUrl) => {
    const res = await api.post(`/subjective-exams/submissions/${submissionId}/submit`, null, {
        params: { pdf_url: pdfUrl }
    });
    return res.data;
};

export const getSubmissions = async (examId) => {
    const res = await api.get(`/subjective-exams/${examId}/submissions`);
    return res.data;
};

export const evaluateSubmission = async (submissionId, questionId, evalData) => {
    const res = await api.post(`/subjective-exams/evaluations/`, evalData, {
        params: { submission_id: submissionId, question_id: questionId }
    });
    return res.data;
};

export const publishResults = async (submissionId) => {
    const res = await api.post(`/subjective-exams/submissions/${submissionId}/publish`);
    return res.data;
};

export const evaluateWithAI = async (submissionId, questionId) => {
    const res = await api.post(`/subjective-exams/submissions/${submissionId}/evaluate-ai/${questionId}`);
    return res.data;
};
